module.exports = __webpack_public_path__ + "img/scarecrow.4d06bdc6.svg";